// Turbo swaps <body> and leaves <html> alone, so a visit between the
// application and auth layouts kept the old layout's html classes: a white
// page under the dark sign-in screen. Only the classes a layout rendered are
// swapped; ones added at runtime (the public layout's `iframe`, the assistant
// dock) stay.
//
// The swap waits for turbo:render and checks that the body was replaced. A
// render from Turbo's cache has no server document to read. A frame navigated
// with data-turbo-action runs a visit that fires both events but renders
// nothing, and its document is the frame layout, whose bare <html> would strip
// every class: the collapsed rail sprang open on each keystroke of a search box.
export function carryLayoutHtmlClasses(): () => void {
  const root = document.documentElement
  let layoutClasses = [...root.classList]
  let incoming: { body: HTMLElement; classes: string[] } | null = null

  const onBeforeRender = (event: Event) => {
    const { newBody } = (event as CustomEvent<{ newBody: HTMLElement }>).detail
    const source = newBody.ownerDocument
    incoming = source === document ? null : { body: newBody, classes: [...source.documentElement.classList] }
  }
  const onRender = () => {
    if (!incoming) return
    const { body, classes } = incoming
    incoming = null
    if (document.body !== body) return
    root.classList.remove(...layoutClasses)
    root.classList.add(...classes)
    layoutClasses = classes
  }

  document.addEventListener('turbo:before-render', onBeforeRender)
  document.addEventListener('turbo:render', onRender)
  return () => {
    document.removeEventListener('turbo:before-render', onBeforeRender)
    document.removeEventListener('turbo:render', onRender)
  }
}
